import DISTRIBUTOR_ABI from 'abis/ShibaBankOperator.json'
import { BANK_OPERATOR_ADDRESS } from 'constants/addresses'
import useRefresh from 'hooks/useRefresh'
import { useCallback, useEffect, useState } from 'react'
import multicall from 'utils/multicall'

/**
 * Gets all public data of Pool contract
 */
const useDistributorData = (chainId: number): boolean => {
  const distributorAddress = BANK_OPERATOR_ADDRESS[chainId]
  const { slowRefresh } = useRefresh()

  const [state, setState] = useState(false)

  const fetchData = useCallback(async () => {
    const userCalls = [
      {
        address: distributorAddress,
        name: 'canDistribute',
      },
    ]

    const [canDistribute] = await multicall(chainId, DISTRIBUTOR_ABI, userCalls)

    setState(Boolean(canDistribute[0]))
  }, [chainId, distributorAddress])

  useEffect(() => {
    fetchData()
  }, [fetchData, slowRefresh])

  return state
}

export default useDistributorData
